import { FmlxButton, FmlxCard } from 'fmlx-common-ui';
import React, { useEffect, useState } from 'react';
import LicenseHeader from '../LicenseHeader';
import LicenseRequest from '../modals/LicenseRequest';
import LicenseActivation from '../modals/LicenseActivation';
import { useNavigate } from 'react-router-dom';
import ModelFactory from 'business/models/ModelFactory';
import { LicenseClient, LicenseDetailDTO } from 'business/models/Models';

const licenseClient: LicenseClient = ModelFactory(LicenseClient, false, true);

function LicenseExpired() {
  const navigate = useNavigate();
  const [showLicenseRequestModal, setShowLicenseRequestModal] = useState(false);
  const [showLicenseActivationModal, setShowLicneseActivationModal] = useState(false);
  const [licenseDetail, setLicenseDetail] = useState<LicenseDetailDTO | null>(null);
  const closeBtnClick = () => {
    navigate('/logout');
  };
  const loadLicenseDetail = async () => {
    const detail = await licenseClient.getLicenseDetail(false);
    setLicenseDetail(detail);
  };
  useEffect(() => {
    loadLicenseDetail();
  }, []);
  return (
    <div id="licenseviolation-licenseexpired-wrapper">
      <FmlxCard
        id="licenseviolation-licenseexpired-card"
        disabled={false}
        draggable={false}
        selectable={false}
        selected={false}
        type=""
        variant={FmlxCard.Variant.OUTLINED}
      >
        <FmlxCard.Body id="licenseviolation-licenseexpired-card-body">
          <LicenseHeader />
          <h5
            id="licenseviolation-licenseexpired-primary-label"
            className="label-primary mb-3"
          >
            Expired License{' '}
            {licenseDetail?.expiryDate &&
              `(${new Date(licenseDetail.expiryDate).toLocaleDateString('en-US')})`}
          </h5>
          <div id="licenseviolation-licenseexpired-message" className="body p-5">
            Your License is expired. Please activate your license again or request the
            license.
          </div>
          <div
            id="licenseviolation-licenseexpired-footer"
            className="licenseViolation_footer py-3"
          >
            <FmlxButton
              id="licenseviolation-licenseexpired-button-close"
              label="CLOSE"
              variant={FmlxButton.Variant.OUTLINE}
              onClick={closeBtnClick}
            />
            <FmlxButton
              id="licenseviolation-licenseexpired-button-activate"
              label="ACTIVATE"
              onClick={() => setShowLicneseActivationModal(true)}
            />
            <FmlxButton
              id="licenseviolation-licenseexpired-button-request-license"
              label="REQUEST LICENSE"
              onClick={() => setShowLicenseRequestModal(true)}
            />
          </div>
        </FmlxCard.Body>
      </FmlxCard>
      {showLicenseRequestModal && (
        <LicenseRequest closeModal={() => setShowLicenseRequestModal(false)} />
      )}
      {showLicenseActivationModal && (
        <LicenseActivation closeModal={() => setShowLicneseActivationModal(false)} />
      )}
    </div>
  );
}

export default LicenseExpired;
